<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Website Development</h2>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="service-details-content">
            <div class="row">
                <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                    <div class="service-details-image">
                        <img src="assets/img/services-image/single-service.jpeg" class="w-100" alt="image">
                    </div>
                </div>
                <div class="col-lg-7 col-md-6 col-sm-12 col-12">
                    <h3>Website Development</h3>
                    <p>
                        At Kaims IT Services, our expert team specializes in website development services. Experience
                        high-performing, digitally transformative web solutions designed for user-friendliness. We craft
                        fully
                        functional, secure websites that contribute to the growth of your business.
                    </p>
                    <p>
                        Kaims IT, a leading website design and web development company based in India, excels in
                        delivering
                        top-notch web development services. We specialize in creating bespoke websites, web
                        applications,
                        and
                        web tools for businesses and startups worldwide. With a track record of 100% project delivery,
                        we
                        ensure
                        the highest level of satisfaction for our clients. Secure and Dynamic Web Application
                        Development
                        Services for Your Business Success At Kaims IT, we provide high-quality web application
                        development
                        services to various industries. Our team of skilled developers is adept in the latest
                        technologies
                        and
                        can tackle complex challenges. We offer end-to-end customised web application development
                        services,
                        from
                        design to deployment, prioritising innovation and quality to create robust and scalable
                        applications
                        that drive business growth.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="features-card-section pt-100 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-12 col-sm-12 text-center">
                <div class="icon mb-4">
                    <img src="assets/img/favicon.png" class="fav-size" alt="image">
                </div>
                <h2 class="mb-4">
                    <strong>Technology We Use</strong>
                </h2>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-html5' ></i>
                    <h3><a>HTML</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-css3' ></i>
                    <h3><a>CSS</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-bootstrap' ></i>
                    <h3><a>Bootstrap</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-php'></i>
                    <h3><a>PHP</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-react'></i>
                    <h3><a>React Js</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-angular'></i>
                    <h3><a>Angular</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-microsoft'></i>
                    <h3><a>.Net</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-vuejs'></i>
                    <h3><a>Vue Js</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-nodejs' ></i>
                    <h3><a>Node Js</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxl-wordpress' ></i>
                    <h3><a>WordPress</a></h3>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <section class="subscribe-area bg-f4f5fe">
    <div class="container">
        <div class="subscribe-content">
            <h2>We always try to be the best support to you as possible</h2>
            <form class="newsletter-form">
                <div class="row align-items-center">
                    <div class="col-lg-8 col-md-8">
                        <input type="email" class="input-newsletter" placeholder="hello&#64;jexsa.com" name="EMAIL"
                            required>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <button type="submit"><i class="bx bxs-hot"></i> Subscribe Now</button>
                    </div>
                </div>
            </form>
            <div class="shape14"><img src="assets/img/shape/shape13.png" alt="image"></div>
            <div class="shape15"><img src="assets/img/shape/shape14.png" alt="image"></div>
            <div class="shape16"><img src="assets/img/shape/shape15.png" alt="image"></div>
            <div class="shape17"><img src="assets/img/shape/shape16.png" alt="image"></div>
            <div class="shape18"><img src="assets/img/shape/shape17.png" alt="image"></div>
        </div>
    </div>
</section> -->

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>We always try to be the best support to you as possible</h2>
            <p>Qualify your leads & recognize the value of word your customer will love you</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i> Contact Us<span></span></a>
        </div>
    </div>
    <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div>
</section>